// node_modules
import { FC } from "react";
// Custom hooks
import { useAdditionalTechnology } from "Hooks";
// styles
import styles from "../TechnologyListItem/technologyListItem.module.scss";

type TAddTechnologyListItemProps = {
    conceptNumbering?: string
};

export const AddTechnologyListItem: FC<TAddTechnologyListItemProps> = ({conceptNumbering} : TAddTechnologyListItemProps) => {
    // Custom hooks
    const [addAdditionalTechnology] = useAdditionalTechnology();

    return (
        <>
            <div className={styles.technologyListItem} onClick={async() => await addAdditionalTechnology(conceptNumbering)}>
                <span className={styles.technologyTitle} title="Add result">+ Add result</span>
            </div>
        </>
    );
};